import { Cell as RTCell, flexRender } from "@tanstack/react-table";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

export default function Cell<RowType>(cell: RTCell<RowType, any>) {
  const {
    focusedColumn,
    selectedColumns,
    classNames,
    onColumnFocus,
    onColumnSelected,
  } = cell.getContext().table.options.meta ?? {};

  const isFocused = focusedColumn === cell.column.id;
  const isSelected = !!selectedColumns?.includes(cell.column.id);

  return (
    <td
      onClick={() => onColumnSelected?.(cell.column)}
      onMouseEnter={() => onColumnFocus?.(cell.column, true)}
      onMouseLeave={() => onColumnFocus?.(cell.column, false)}
      className={twMerge(
        clsx({
          "bg-primary/25": isSelected && isFocused,
          "bg-primary/10": isSelected && !isFocused,
          "bg-gunmetal-50": !isSelected && isFocused,
          "px-3.5 py-2.5": cell.getContext().table.options.meta?.size === "lg",
          "px-2 py-1.5": cell.getContext().table.options.meta?.size === "sm",
          "border border-gunmetal-100":
            cell.getContext().table.options.meta?.bordered,
        }),
        typeof classNames?.cell === "function"
          ? classNames?.cell(cell)
          : classNames?.cell
      )}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
}
